<template>
    <div class="evaluateDescribeBox">
        <div class="evaluateDescribeContent">
            <div class="projectBox">
                <div class="projectTop">
                    <div class="projectTitle">评价项⽬</div>
                    <div class="projectBage">{{format.groupName}}</div>
                </div>
                <p class="projectDescribe">{{format.normalItem}}</p>
            </div>
            <div class="resultBox">
                <div class="resultTitle">评价结果</div>
                <div class="evaluateResult">
                    <div class="imgBox">
                        <img v-if="format.ratingType === 1" src="../../../../assets/image/ic_you@2x.png" alt="">
                        <img v-else-if="format.ratingType === 2" src="../../../../assets/image/ic_l@2x.png" alt="">
                        <img v-else-if="format.ratingType === 3" src="../../../../assets/image/ic_z@2x.png" alt="">
                        <img v-else-if="format.ratingType === 4" src="../../../../assets/image/ic_c@2x.png" alt="">
                        <div v-else>{{format.ratingType}}</div>
                    </div>
                </div>
            </div>
                <div class="projectBox">
                    <div class="projectItem">
                        <div class="projectList">评价描述</div>
                        <p class="projectDescribe">{{format.memo || '暂无'}}</p>
                    </div>
                </div>
            <div class="enclosureBox" v-if="fileList && fileList.length">
                <div class="enclosureTitle">附件</div>
                    <better-scroll class="enclosureList" :scrollX="true">
                        <div class="enclosureListItem">
                            <video class="showVideo" v-for="item in fileListVideo" :key="item.cosKey" :src="item" @click="showViewerVideo(item)"></video>
                            <img v-for="(item, index) in fileList" :key="index" @click="showViewer(index, $event, fileList)" :src="item">
                        </div>
                    </better-scroll>
            </div>
             <div class="projectBox" v-else>
                <div class="accessory">
                    <div class="projectTitle">附件</div>
                    <div class="projectfile">无附件</div>
                </div>
             </div>
        </div>
        <playerTv ref="playerTv" :playUrl="playUrl"></playerTv>
    </div>
</template>

<script>
    import betterScroll from '../../../../components/base/betterScroll';
    import api from '../../../../service/modules/integrity'
    import playerTv from '../home/playerTv'
    export default {
        components: {
            'better-scroll': betterScroll,
            playerTv
        },
        data () {
            return {
                format: {},
                fileList: [],
                fileListVideo: [],
                playUrl: '',
                postUrl: '',
                moveList: []
                // fileList: ['http://img5.imgtn.bdimg.com/it/u=3437217665,1564280326&fm=26&gp=0.jpg', 'http://img5.imgtn.bdimg.com/it/u=3437217665,1564280326&fm=26&gp=0.jpg', 'http://img5.imgtn.bdimg.com/it/u=3437217665,1564280326&fm=26&gp=0.jpg', 'http://img5.imgtn.bdimg.com/it/u=3437217665,1564280326&fm=26&gp=0.jpg', 'http://img5.imgtn.bdimg.com/it/u=3437217665,1564280326&fm=26&gp=0.jpg', 'http://img5.imgtn.bdimg.com/it/u=3437217665,1564280326&fm=26&gp=0.jpg'] // 图片
            }
        },
        created () {
            this.getWorkOrderScoringDetail()
        },
        methods: {
            // 图片预览
            showViewer (index, event, imgList) {
                this.$router.push({
                  path: '/complaint/imagesView',
                  query: {
                    imageList:imgList|| [],
                    index
                  },
                })

                // this.$ImagePreview({ images: imgList, startPosition: index, closeOnPopstate: true });
            },
            // 工单评分细则列表
            getWorkOrderScoringDetail () {
                api.getScoringItems({ rtedId: this.$route.query.id }).then(res => {
                    if (res.ret === 0) {
                        let data = res.data
                        this.format = data.executeDetail;
                        // this.fileList = data.fileList;
                        if (data.fileList && data.fileList.length) {
                            let arrObj = data.fileList.filter(e => e.fileType === 'image/jpg')
                            let brrObj = data.fileList.filter(e => e.fileType === 'video/mp4')
                            let arr = []
                            let brr = []
                            for (var i = 0; i < arrObj.length; i++) {
                                arr.push(arrObj[i].url)
                            }
                            this.fileList = arr
                            for (var j = 0; j < brrObj.length; j++) {
                                brr.push(brrObj[j].fileUrl)
                            }
                            this.fileListVideo = brr
                        }
                    }
                })
            },
            // 图片预览
            showViewerVideo (item) {
                this.playUrl = '';
                this.postUrl = item.url;
                this.playUrl = item;
                this.$refs.playerTv.showPlayer();
            }
        }
    }
</script>

<style lang="less" scoped>
    .evaluateDescribeBox{
        margin: 0 12px 24px;
        background-color: #FBFBFB;
        .evaluateDescribeContent{
            padding: 24px 12px;
            background-color: #fff;
            border-radius: 3px;

            .projectBox{
                margin-bottom: 24px;

                .projectTop::after{
                    content: '';
                    display: block;
                    clear: both;
                }

                .projectTop{
                    margin-bottom: 12px;
                    display: flex;
                    >div{
                        float: left;
                    }

                    .projectTitle{
                        margin-right: 12px;
                        font-size: 16px;
                        font-weight: bold;
                        color: #333;
                    }

                    .projectBage{
                        padding: 2px 4px;
                        font-size: 10px;
                        line-height: 10px;
                        color: #36B374;
                        border: 0.5px solid #36B374;
                        -webkit-transform: scale(0.84);
                    }
                }

                .accessory{
                    .projectTitle{
                        margin-right: 8px;
                        font-size: 16px;
                        font-weight: bold;
                        color: #333;
                        margin-bottom: 16px;
                    }
                    .projectfile{
                        font-size: 14px;
                        color: #666;
                    }
                }

                .projectDescribe{
                    font-size: 14px;
                    line-height: 20px;
                    color: #666;
                }
                .projectItem{
                    font-size: 14px;
                    .projectList{
                        margin-bottom: 12px;
                        color: #333;

                    }
                    .projectDescribe{
                        color: #666;
                        line-height: 20px;
                    }
                }
            }

            .resultBox{
                margin-bottom: 16px;

                .resultTitle{
                    font-size: 16px;
                    font-weight: bold;
                    color: #333;
                }

                .evaluateResult{
                    display: flex;
                    justify-content: center;
                    width: 100%;
                    margin: 16px 0;
                    .imgBox{
                        // margin-bottom: 10px;
                        width: 70px;
                        height: 50px;
                        .img{
                            display: inline-block;
                        }
                    }
                }

                .resultDescribe{
                    font-size: 16px;
                    font-weight: bold;
                    line-height: 18px;
                    color: #666;
                }
            }

            .enclosureBox{

                .enclosureTitle{
                    margin-bottom: 12px;
                    font-size: 16px;
                    font-weight: bold;
                }

                .enclosureList{
                    width: 100%;
                    height: 80px;
                    overflow: hidden;
                    position: relative;
                    .enclosureListItem{
                        // height: 80px;
                        // display: inline-block;
                        white-space: nowrap;
                        position: absolute;
                        .showVideo{
                          margin-right: 10px;
                          width: 80px;
                          height: 80px;
                        }
                        >img{
                            width: 74px;
                            height: 74px;
                            display: inline-block;
                            margin-right: 12px;
                            border-radius: 3px;
                        }
                    }
                // .imgList {
                //       width: 100%;
                //       height: 80px;
                //       overflow: hidden;
                //       position: relative;
                //       .warp {
                //         white-space: nowrap;
                //         position: absolute;
                //         img {
                //           width: 80px;
                //           height: 80px;
                //           display: inline-block;
                //           margin-right: 10px;
                //         }
                //       }
                //     }
                }
            }
        }
    }
</style>
